import { render, staticRenderFns } from "./DataProfileInfo.vue?vue&type=template&id=9d9eefa4&scoped=true&"
import script from "./DataProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./DataProfileInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9eefa4",
  null
  
)

export default component.exports